import script from "./PlatformPaymentBreakdownModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PlatformPaymentBreakdownModal.vue?vue&type=script&setup=true&lang=js"

import "./PlatformPaymentBreakdownModal.vue?vue&type=style&index=0&id=473a9502&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-473a9502"]])

export default __exports__